import moment from 'moment-timezone';

export const LESSON_DATE_FORMAT = 'DD/MM/YY - HH:mm';

export const formatLessonDate = (datetime?: string | Date | null): string => {
  if (!datetime) return '';

  const date = moment(datetime);

  if (!date.isValid()) return '';

  return date.format(LESSON_DATE_FORMAT);
};
